module.exports = __webpack_public_path__ + "static/media/amulet_06.4508337d.png";